const SCREENSIZES = {
    MOBILEMAX: 768,
    TABLETMIN: 769,
    TABLETMAX: 1440,
    DESKTOPMIN: 1441
};

const POINTS = 'Points';
const CREDIT_CARD = 'CREDIT_CARD';
const LABEL_CARD = 'card';
const BONVOY_POINTS = 'BONVOY_POINTS';
const DEPT_CODE = 'DEPT_CODE';
const LOYALTYOTPDIGITS = 6;
const CUSTOM_PRODUCT_SET_QTY = 1;
const GIFT_MESSAGE_PATTERN = /^[a-zA-Z0-9!"()&*'#.,:-\s]*$/;
const CHECK_MATTRESS_PRODUCT = 'Mattresses';
const ACCEPTED_PRIVACY_COOKIE_EXPIRY = '7776000';
const QUICKVIEW_PRODUCT_DETAILS_FOOTER_HEIGHT = 150;

module.exports = {
    SCREENSIZE: SCREENSIZES,
    POINTS: POINTS,
    CREDIT_CARD: CREDIT_CARD,
    LABEL_CARD: LABEL_CARD,
    BONVOY_POINTS: BONVOY_POINTS,
    DEPT_CODE: DEPT_CODE,
    LOYALTYOTPDIGITS:LOYALTYOTPDIGITS,
    CUSTOM_PRODUCT_SET_QTY:CUSTOM_PRODUCT_SET_QTY,
    GIFT_MESSAGE_PATTERN:GIFT_MESSAGE_PATTERN,
    CHECK_MATTRESS_PRODUCT:CHECK_MATTRESS_PRODUCT,
    ACCEPTED_PRIVACY_COOKIE_EXPIRY:ACCEPTED_PRIVACY_COOKIE_EXPIRY,
    QUICKVIEW_PRODUCT_DETAILS_FOOTER_HEIGHT:QUICKVIEW_PRODUCT_DETAILS_FOOTER_HEIGHT
};

